/**
 * @generated SignedSource<<e1c15f16e679a99e76e5943d5b443018>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DominantColorPersister_project$data = {
  readonly canEditProjectConfig: {
    readonly canPerform: boolean;
  };
  readonly projectId: string;
  readonly " $fragmentType": "DominantColorPersister_project";
};
export type DominantColorPersister_project$key = {
  readonly " $data"?: DominantColorPersister_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"DominantColorPersister_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "DominantColorPersister_project",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectId"
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "canEditProjectConfig",
        "args": [
          {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
          }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "canPerform"
            },
            "action": "THROW"
          }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
      },
      "action": "THROW"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "2ba43559df1c04b5fbcfbc5b3682e35a";

export default node;
